import requester from 'core/http/requester';

export default {
  async getIsFeedbackAllowed(defaultNpsUrl: string, courseId: string, userId: string) {
    try {
      const request = await requester.get(`${defaultNpsUrl}/summary/allow-learner-feedback`, {
        headers: {
          'X-Entity-Type': 'course',
          'X-Entity-Id': courseId,
          'X-User-Id': userId
        }
      });
      const response = await request.json();
      return response.isFeedbackAllowed;
    } catch (e) {
      console.error('Error in retrieving learner feedback status:', e);
      return false;
    }
  }
};
